(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    (function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    if (!window.MarketlyCart) return;

    var variantId = btn.dataset.upsellAdd;
    btn.disabled = true;
    btn.dataset.state = 'loading';

    window.MarketlyCart.add(variantId, 1)
      .then(function () {
        btn.dataset.state = 'added';
        setTimeout(function () {
          btn.dataset.state = '';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.dataset.state = '';
        btn.disabled = false;
      });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Delegated event handling - one listener for all product cards, guard prevents duplicate registration
if (!document.body.dataset.cardQtyDelegate) {
  document.body.dataset.cardQtyDelegate = '1';

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.product-card');
    if (!card) return;

    // -- Variant pill --
    var pill = e.target.closest('.product-card__pill');
    if (pill) { pcPillSelect(card, pill); return; }

    // -- Qty minus --
    if (e.target.closest('[data-card-qty-minus]')) { pcQtyChange(card, -1); return; }

    // -- Qty plus --
    if (e.target.closest('[data-card-qty-plus]')) { pcQtyChange(card, 1); return; }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product-card__form');
    if (!form) return;
    e.preventDefault();
    pcAtcSubmit(form);
  });
}

function pcPillSelect(card, pill) {
  var jsonEl = card.querySelector('.product-card__variants-json');
  if (!jsonEl) return;

  var variants;
  try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

  var val = pill.dataset.optionValue;
  var idx = pill.dataset.optionIndex;
  var key = 'o' + idx;

  var match = variants.find(function (v) { return v[key] === val && v.available; })
           || variants.find(function (v) { return v[key] === val; });
  if (!match) return;

  // Active pill
  card.querySelectorAll('.product-card__pill[data-option-index="' + idx + '"]').forEach(function (p) {
    p.classList.toggle('is-selected', p === pill);
  });

  // Variant input
  var inp = card.querySelector('[data-variant-id]');
  if (inp) inp.value = match.id;

  // Price
  var priceEl = card.querySelector('[data-price]');
  if (priceEl) {
    priceEl.textContent = match.price;
    priceEl.classList.toggle('product-card__price--sale', match.has_sale);
  }

  // Compare price
  var compareEl = card.querySelector('[data-compare]');
  if (compareEl) {
    if (match.compare_price) {
      compareEl.textContent = match.compare_price;
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }

  // Unit price
  var unitEl = card.querySelector('[data-unit-price]');
  if (unitEl) {
    if (match.unit_price) {
      unitEl.textContent = match.unit_price + (match.unit_price_measure ? ' ' + match.unit_price_measure : '');
      unitEl.style.display = '';
    } else {
      unitEl.style.display = 'none';
    }
  }

  // Available state
  var atcForm = card.querySelector('.product-card__form');
  var soldBtn = card.querySelector('.product-card__sold-out-btn');
  var overlay = card.querySelector('.product-card__sold-overlay');

  if (match.available) {
    card.classList.remove('product-card--sold-out');
    if (atcForm) atcForm.style.display = '';
    if (soldBtn) soldBtn.style.display = 'none';
    if (overlay) overlay.style.display = 'none';
  } else {
    card.classList.add('product-card--sold-out');
    if (atcForm) atcForm.style.display = 'none';
    if (soldBtn) { soldBtn.style.display = ''; }
    // Create overlay if it doesn't exist (product had available variants on page load)
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'product-card__sold-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg><span>' + (soldBtn ? soldBtn.textContent.trim() : 'Sold out') + '</span>';
      var wrap = card.querySelector('.product-card__media-wrap');
      if (wrap) wrap.appendChild(overlay);
    } else {
      overlay.style.display = '';
    }
  }
}

function pcQtyChange(card, delta) {
  var numEl = card.querySelector('[data-card-qty-num]');
  var hiddenEl = card.querySelector('[data-qty-hidden]');
  if (!numEl) return;

  var next = Math.max(1, (parseInt(numEl.textContent, 10) || 1) + delta);
  numEl.textContent = next;
  if (hiddenEl) hiddenEl.value = next;

  var qvBtn = card.querySelector('[data-quick-view]');
  if (qvBtn) qvBtn.dataset.quickViewQty = next;
}

function pcAtcSubmit(form) {
  var btn = form.querySelector('.product-card__atc');
  var varInp = form.querySelector('[data-variant-id]');
  var qtyInp = form.querySelector('[data-qty-hidden]');
  if (!varInp) return;

  if (btn) btn.disabled = true;

  var variantId = parseInt(varInp.value, 10);
  var qty = parseInt((qtyInp && qtyInp.value) || '1', 10);

  function onSuccess() {
    var card = form.closest('.product-card');
    var numEl = card && card.querySelector('[data-card-qty-num]');
    var hiddenEl = form.querySelector('[data-qty-hidden]');
    if (numEl) numEl.textContent = 1;
    if (hiddenEl) hiddenEl.value = 1;
    if (btn) {
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.disabled = false;
      }, 1500);
    }
  }

  function onError() {
    if (btn) {
      btn.disabled = false;
      btn.classList.add('is-error');
      setTimeout(function () { btn.classList.remove('is-error'); }, 800);
    }
  }

  // Delegate to central cart engine (handles drawer/page/mini, badge, section refresh)
  if (window.MarketlyCart) {
    window.MarketlyCart.add(variantId, qty)
      .then(onSuccess)
      .catch(onError);
    return;
  }

  // Fallback: MarketlyCart not yet loaded (unlikely with defer, but safe)
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { onError(); return; }
      onSuccess();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(onError);
}
  } catch(e) { console.error(e); }
})();

})();
